
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexeBRzLUP2pab7kmyXi2DMddZaKPwIA3k5tJMXsMYC8EcMeta } from "/builds/bunuble/bunuble/bunuble/pages/index.vue?macro=true";
import { default as mapb3NBHKiuQl2tdDzsfSV5wlgvBc8GjDqN2JotDeLmu9wMeta } from "/builds/bunuble/bunuble/bunuble/pages/map.vue?macro=true";
import { default as authIJZOkTL7kJVKlZ1O_45kbL8HWbliKWYWljGoXfSj4yHlMMeta } from "/builds/bunuble/bunuble/bunuble/pages/auth.vue?macro=true";
import { default as adminrvM6TRpEYgag7NX3PAdOqOoYNfgr27FlW5G4UR2mZ_4Meta } from "/builds/bunuble/bunuble/bunuble/pages/admin.vue?macro=true";
import { default as businessaQOAgeFuDlGmR7cTSMoIAiyMgv8fnHNPO5EtRDXczNEMeta } from "/builds/bunuble/bunuble/bunuble/pages/business.vue?macro=true";
import { default as settings4jzIB4oh_45F59vIC1itlXRZ_LybQyrD2cg_45CDnJ2asdwMeta } from "/builds/bunuble/bunuble/bunuble/pages/settings.vue?macro=true";
import { default as indexCyyeQHGk5Z5mHP5F_45M03p4C3d7VdbXo3MuAGASBHIMYMeta } from "/builds/bunuble/bunuble/bunuble/pages/about/index.vue?macro=true";
import { default as termsj8G9_45_9ErRWmOGMxDHqz02eQltaTf98L6HxIe8MKiUUMeta } from "/builds/bunuble/bunuble/bunuble/pages/about/terms.vue?macro=true";
import { default as privacykHcHtOldy60AiggmGQmH8KMdiufr5LUDgwG8xLAJmH0Meta } from "/builds/bunuble/bunuble/bunuble/pages/about/privacy.vue?macro=true";
import { default as _91title_93u1pTRMIXC_453pDOOWYjXSnDmEZMWHGV9cKkthQJlmzSQMeta } from "/builds/bunuble/bunuble/bunuble/pages/[vertical]/[businessName]/[title].vue?macro=true";
import { default as component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta } from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@9.27.0_jiti@2.4_30c1de93e8f0506f253d4b3e778cf64d/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI } from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_db0@0.3.2_eslint@9.27.0_jiti@2.4_30c1de93e8f0506f253d4b3e778cf64d/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"tmp-redirect-from-index"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/index.vue")
  },
  {
    name: "map___en",
    path: "/en/map",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/map.vue")
  },
  {
    name: "map___de",
    path: "/de/map",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/map.vue")
  },
  {
    name: "auth___en",
    path: "/en/auth",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/auth.vue")
  },
  {
    name: "auth___de",
    path: "/de/auth",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/auth.vue")
  },
  {
    name: "admin___en",
    path: "/en/admin",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/admin.vue")
  },
  {
    name: "admin___de",
    path: "/de/admin",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/admin.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: {"middleware":"tmp-redirect-from-index"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: {"middleware":"tmp-redirect-from-index"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/index.vue")
  },
  {
    name: "business___en",
    path: "/en/business",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/business.vue")
  },
  {
    name: "business___de",
    path: "/de/business",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/business.vue")
  },
  {
    name: "settings___en",
    path: "/en/settings",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/settings.vue")
  },
  {
    name: "settings___de",
    path: "/de/settings",
    meta: {"middleware":"auth"},
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/settings.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/about/index.vue")
  },
  {
    name: "about___de",
    path: "/de/about",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/about/index.vue")
  },
  {
    name: "about-terms___en",
    path: "/en/about/terms",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/about/terms.vue")
  },
  {
    name: "about-terms___de",
    path: "/de/about/terms",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/about/terms.vue")
  },
  {
    name: "about-privacy___en",
    path: "/en/about/privacy",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/about/privacy.vue")
  },
  {
    name: "about-privacy___de",
    path: "/de/about/privacy",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/about/privacy.vue")
  },
  {
    name: "vertical-businessName-title___en",
    path: "/en/:vertical()/:businessName()/:title()",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/[vertical]/[businessName]/[title].vue")
  },
  {
    name: "vertical-businessName-title___de",
    path: "/de/:vertical()/:businessName()/:title()",
    component: () => import("/builds/bunuble/bunuble/bunuble/pages/[vertical]/[businessName]/[title].vue")
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/en/index-sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/de/index-sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/en/en-sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/de/en-sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/en/de-sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  },
  {
    name: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLIMeta?.name,
    path: "/de/de-sitemap.xml",
    component: component_45stub4o6yGtIN3_45556OWeXHihapqA8xNh3cYd8XxQtCLGPLI
  }
]